<template>
  <div>
    <p>View your customers</p>
    <a-card style="margin: 20px 0;" title="Customer Search" class="needColumn">
      <a-input placeholder="input search text"
               size="large"
               @change="onSearchEdit($event.target.value)"
               :value="foundCustomer"
      >
      </a-input>
      <a-button @click="onSearch" size="large">Search</a-button>
      <a-button v-if="isAdmin" @click="showAll()" size="large">Show all customers</a-button>
    </a-card>
    <a-card style="margin: 20px 0;" title="Search Results" :bordered="false">
      <a-table :columns="columns"
               :dataSource="customers"
               :pagination="{ pageSize: 10 }"
               rowKey="id">
        <span slot="pointsManage" slot-scope="text,record">
          <a-button @click="navigate('GivePoints' , {user_id : record.userId})"
                    type="primary">
            Manage
          </a-button>
        </span>
        <span slot="rewardsManage" slot-scope="text,record">
          <a-button @click="navigate('ManageRewards' , {user_id : record.userId})"
                    type="primary">
            Manage
          </a-button>
        </span>
      </a-table>

      <div style="margin-top: 30px">
        <a-button v-if="isAdmin"
                  style="margin: 0 auto;display: flex;"
                  @click="csvExport()"
                  type="primary">
          Export
        </a-button>
      </div>
    </a-card>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import {API_URL} from '../../constants'

const columns = [ {
  title: 'Member Email',
  dataIndex: 'email',
  width: 250,
}, {
  title: 'Member Name',
  dataIndex: 'name',
  width: 120,
}, {
  title: 'Last Purchase',
  dataIndex: 'last_purchase',
  width: 250,
}, {
  title: 'Points',
  dataIndex: 'purchase_progress',
  width: 100,
}, {
  title: 'Reward Collected',
  dataIndex: 'rewards_collected',
  width: 150,
}, {
  title: 'Points',
  dataIndex: 'pointsManage',
  width: 150,
  key: 'pointsManage',
  scopedSlots: { customRender: 'pointsManage' },
}, {
  title: 'Rewards',
  dataIndex: 'rewardsManage',
  width: 150,
  key: 'rewardsManage',
  scopedSlots: { customRender: 'rewardsManage' },
} ]

export default {
  name: 'CustomerView',
  data () {
    return {
      message: '',
      columns,
      API_URL,

    }
  },
  mounted () {
    if (this.isAdmin) {
      this.$store.dispatch('loyalty/getCustomers')
    }

    this.$store.dispatch('loyalty/getLoyaltyData')
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
    onSearch () {
      this.$store.dispatch('loyalty/findCustomerByEmail')
    },
    onSearchEdit (value) {
      this.$store.commit('loyalty/changeCustomerSearch', value)
    },
    showAll () {
      this.$store.dispatch('loyalty/getCustomers')
    },
    navigate (name, params) {
      this.$router.push({name, params})
    },
    csvExport () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      const items = this.exportCustomers
      const replacer = (key, value) => value === null ? '' : value
      const header = Object.keys(items[0])
      let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')
      csvContent += csv
      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'Customers.csv')
      link.click()
    },
  },
  computed: {
    ...mapState({
      customers: state => {
        return state.loyalty.customers.map(customer => ({
          id: customer.id,
          userId: customer.user.id,
          email: customer.user.email,
          name: `${customer.user.first_name} ${customer.user.last_name}`,
          last_purchase: moment(customer.updated_at).fromNow(),
          purchase_progress: `${customer.purchase_progress}0/${state.loyalty.loyaltyProgram.purchase_count}0`,
          rewards_collected: customer.rewards_collected,
        }))
      },
      exportCustomers: state => {
        return state.loyalty.customers.map(customer => ({
          email: customer.user.email,
          name: `${customer.user.first_name} ${customer.user.last_name}`,
          last_purchase: 'last_purchase',
          purchase_progress: `${customer.purchase_progress}0/${state.loyalty.loyaltyProgram.purchase_count}0`,
          rewards_collected: customer.wallet && customer.wallet.redeemed,
        }))
      },
      foundCustomer: state => state.loyalty.foundCustomer,
      user: state => state.auth.user,
      offer: state => state.offer.offer,
      isAdmin: state => !state.auth.agent || (state.auth.agent.roles && state.auth.agent.roles[0] === 'admin'),
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerView.vue